<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">
        {{ form.id == 0 ? "CREATE" : "UPDATE" }} CONVERSATION TOPIC
      </p>
    </template>
    <b-row no-gutters>
      <b-col cols="12" class="mb-2" v-if="topicGroupEnable"
        ><span class="text-title">Main Topic</span></b-col
      >
      <b-col cols="9">
        <InputText
          v-model="form.name"
          name="form.name"
          textFloat="Name"
          placeholder="Name"
          type="text"
          isRequired
          :isValidate="$v.form.name.$error"
          :v="$v.form.name"
        />
      </b-col>
      <b-col cols="3" class="pl-3">
        <InputText
          v-model="form.sortOrder"
          textFloat="Sort Order"
          placeholder="Sort Order"
          type="text"
          isRequired
          :isValidate="$v.form.sortOrder.$error"
          :v="$v.form.sortOrder"
        />
      </b-col>
      <b-col cols="12">
        <label class="text-title"> SubTopic </label>
        <toggle-button
          v-if="topicGroupEnable && visibleToggle"
          :value="isTopicGroup"
          class="mt-1 ml-2"
          :color="{
            checked: '#27BDA7',
            unchecked: '#B0B0B0',
          }"
          @change="handleToggleSubTopic"
        />
      </b-col>
    </b-row>
    <b-row no-gutters v-if="topicGroupEnable && isTopicGroup">
      <b-row v-for="(item, index) in form.topics" :key="index">
        <b-col cols="8" class="pl-5">
          <InputText
            v-model="item.name"
            :name="'form.topics[' + index + '].name'"
            textFloat="Name"
            placeholder="Name"
            type="text"
            isRequired
            :isValidate="$v.form.topics.$each[index].name.$error"
            :v="$v.form.topics.$each[index].name"
          />
          <!--  -->
        </b-col>
        <b-col cols="3" class="pl-3">
          <InputText
            v-model="item.sortOrder"
            :name="'form.topics[' + index + '].sortOrder'"
            textFloat="Sort Order"
            placeholder="Sort Order"
            type="text"
            isRequired
            :isValidate="$v.form.topics.$each[index].sortOrder.$error"
            :v="$v.form.topics.$each[index].sortOrder"
          />
        </b-col>

        <b-col
          v-if="!item.id"
          cols="1"
          class="pr-4 mt-2 d-flex justify-content-center align-items-center"
        >
          <font-awesome-icon
            @click="handleDeleteSubTopic(index)"
            icon="trash-alt"
            class="text-danger cursor-pointer"
            title="Delete"
        /></b-col>
        <!-- 
            -->
      </b-row>
    </b-row>
    <b-row no-gutters v-if="topicGroupEnable && isTopicGroup">
      <span class="ml-2 text-add-sub-topic" @click="handleClickAddSubTopic">
        Add Sub Topic</span
      >
    </b-row>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button :disabled="isLoading" class="cancel-button" @click="hide()">
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";

import {
  required,
  integer,
  minValue,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  name: "ModalCreateOrEdit",
  components: {
    InputText,
  },
  props: {
    topicGroupEnable: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        name: { required },
        sortOrder: {
          required,
          integer,
          minValue: minValue(0),
        },

        topics: {
          $each: {
            name: { required },
            sortOrder: {
              required,
              integer,
              minValue: minValue(0),
            },
          },
        },
      },
    };
  },
  data: function () {
    return {
      showModal: false,
      form: {
        id: 0,
        name: "",
        sortOrder: "",
        isActive: true,
        topics: [],
      },
      isLoading: false,
      isTopicGroup: false,
      visibleToggle: true,
    };
  },
  methods: {
    show(item) {
      this.$v.$reset();
      if (item === null) {
        this.form = {
          id: 0,
          name: "",
          sortOrder: "",
          isActive: true,
        };
        if (this.topicGroupEnable) {
          this.visibleToggle = true;
        }
      } else {
        if (this.topicGroupEnable && item.groupId) {
          this.form = { ...item, topics: item.topics, isDeleted: 0 };
          this.isTopicGroup = true;
          this.visibleToggle = false;
        } else {
          this.form = { ...item };
          this.isTopicGroup = false;
          this.visibleToggle = true;
        }
      }
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      this.isTopicGroup = false;
    },
    async saveTopic() {
      const response = await this.axios.post(
        `${this.$baseUrl}/FlowBuilder/Topics`,
        this.form
      );
      return response;
    },
    async saveTopicGroup() {
      const response = await this.axios.post(
        `${this.$baseUrl}/FlowBuilder/TopicsGroup`,
        this.form
      );
      return response;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      try {
        const data =
          this.topicGroupEnable &&
          this.isTopicGroup &&
          (this.form.isDeleted === 0 || !this.form.isDeleted)
            ? await this.saveTopicGroup()
            : await this.saveTopic();
        if (data.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: data.message,
          });
          this.$emit("reloadData");
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: data.message,
          });
        }
      } catch (err) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: err.message,
        });
      }

      this.isLoading = false;
    },
    handleClickAddSubTopic() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      if (!this.form.topics) {
        this.$set(this.form, "topics", [this.newTopic()]);
      } else {
        this.form.topics.push(this.newTopic());
      }
    },
    newTopic() {
      return {
        name: "",
        sortOrder: this.form.topics ? this.form.topics.length + 1 : 1,
        topicGroupId: this.form.groupId,
        isActive: true,
      };
    },
    handleToggleSubTopic() {
      this.isTopicGroup = !this.isTopicGroup;
      const newTopic = this.newTopic();
      const hasFormId = !!this.form.id;
      const hasTopicGroupId = !!newTopic.topicGroupId;

      if (this.isTopicGroup) {
        this.$set(this.form, "topics", [newTopic]);

        if (hasFormId && !hasTopicGroupId) {
          this.form.isDeleted = 1;
        }
      } else {
        this.$v.$reset();
        this.form.topics = [];

        if (hasFormId && !hasTopicGroupId) {
          this.form.isDeleted = 0;
        }
      }
    },
    handleDeleteSubTopic(index) {
      this.form.topics.splice(index, 1);
      this.form.topics.forEach((element, bindex) => {
        element.sortOrder = bindex + 1;
      });
    },
  },
};
</script>

<style scoped>
.text-title {
  font-size: 18px;
  font-weight: bold;
}
.text-add-sub-topic {
  font-size: 14px;
  font-weight: bold;
  color: #7160c4;
  text-decoration: underline;
  cursor: pointer;
}
</style>
